import styles from "./Profile.module.css";
import frame from "../../assets/profileBackImg.png";
import profileImg from "../../assets/profileImg.png";
import cameraImg from "../../assets/cameraIcon.png";
import SubmitButton from "../../components/submitButton/SubmitButton";
import { AntdSubmit } from "../../components";
import React, { useEffect, useRef, useState } from "react";
import dummyImg from "../../assets/dummy.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { IMG_URL } from "../../store/Apis";
import AuthMiddleware from "../../store/Middlewares/AuthMiddleware";
import { useTranslation } from "react-i18next";
import moment from "moment/moment";
import { roles } from "../../config/roles";

const Profile = () => {
  const phoneFormat = (text) => {
    var cleaned = ("" + text).replace(/\D/g, "");
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      var intlCode = match[1] ? "+1 " : "",
        number = [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
          ""
        );
      return number;
    }
    return text;
  };
  const { t, i18n } = useTranslation();
  const role = localStorage.getItem("role");
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [profileImg, setProfileImg] = useState("");
  const hiddenFileInput = React.useRef();
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const user = useSelector((state) => state.AuthReducer.user);
  console.log("user", user);
  useEffect(() => {
    getLanguage();
    getUser()
  }, [])

  const getUser = () => {
    dispatch(AuthMiddleware.getUserInfo())
  }

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem("@selectedLanguage");
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <div className={styles.profile_mainCon}>
      <h1 className={styles.heading}>{t("Profile")}</h1>
      <div className={styles.profile_subCon}>
        <div className={styles.profile_subLeftCon}>
          <div className={styles.profile_frame}>
            <img src={frame} />
          </div>
          {/* <div className={styles.editProfileDiv}>
                      <img
                        className={styles.editProfileCameraImg}
                        src={
                          profileImg ? URL.createObjectURL(profileImg) : dummImg
                        }
                      />
                      <div className={styles.editProfileCameraPic}>
                        <AiFillCamera
                          className={styles.editProfileCameraIcon}
                          onClick={handleClick}
                        />
                      </div>
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => setProfileImg(e.target.files[0])}
                      ref={hiddenFileInput}
                      style={{ display: "none" }}
                    />
                  </div> */}
          <div className={styles.profile_mainProfile}>
            <div className={styles.profile_subProfile}>
              <img
                src={
                  user?.profile_image ? IMG_URL + user?.profile_image : dummyImg
                }
              />
            </div>
            {/* <div className={styles.profile_cameraIcon}>
              <img src={cameraImg} onClick={handleClick} />
            </div>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setProfileImg(e.target.files[0])}
              ref={hiddenFileInput}
              style={{ display: "none" }}
            /> */}
          </div>
        </div>
        <div className={styles.profile_subRightCon}>
          <div className={styles.heading2}>
            <h2>{t("Profile")}</h2>
          </div>
          <div className={styles.subContentRow}>
            <div className={styles.subContentColLeft}>
              <span>{t("First Name")}</span>
              <p>{user?.first_name}</p>
            </div>
            <div className={styles.subContentColRight}>
              <span>{t("Contact Number")}</span>
              <p>
                {user?.contact_no
                  ? phoneFormat(user?.contact_no)
                  : "No contact number"}
              </p>
            </div>
          </div>
          <div className={styles.subContentRow}>
            <div className={styles.subContentColLeft}>
              <span>{t("Last Name")}</span>
              <p>{user?.last_name}</p>
            </div>
            <div className={styles.subContentColRight}>
              {/* <span>Address</spsan> */}
              <div className={styles.subContentColLeft}>
                <span>{t("Email")}</span>
                <p>{user?.email}</p>
              </div>
            </div>
          </div>
          {role == roles.customer ? (
            <>
              <div className={styles.subContentRow}>
                <div className={styles.subContentColLeft}>
                  <span>{t("Company Name")}</span>
                  <p>{user?.company?.name}</p>
                </div>
                <div className={styles.subContentColRight}>
                  <div className={styles.subContentColLeft}>
                    <span>{t("Comapany Address")}</span>
                    <p>{user?.company?.address}</p>
                  </div>
                </div>
              </div>
              <div className={styles.subContentRow}>
                <div className={styles.subContentColLeft}>
                  <span>{t("Company Contact Number")}</span>
                  <p>{user?.company?.contact_no? phoneFormat(user?.company?.contact_no)
                  : "No contact number"}</p>
                </div>
                <div className={styles.subContentColRight}>
                  <div className={styles.subContentColLeft}>
                    <span>{t("Website Link")}</span>
                    <p>
                      {user?.company?.website ? (
                        <a target="_blank" href={user?.company?.website}> {user?.company?.website}</a>
                      ) : (
                        "--"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </>
          ) : null}
          {role == roles.customer ?null:<div className={styles.subContentRow}>
            <div className={styles.subContentColLeft}>
              {user?.addresses?.length > 0 ? (
                <>
                  {user?.addresses?.map((item, index) => {
                    return (
                      <div key={index}>
                        <div style={{ margin: '10px 0px' }}>
                          <span>{user?.addresses?.length > 1 ? "Address " + parseInt(index + 1) : "Address"}</span>
                        </div>
                        <p style={{ margin: 0 }}>{item.address == 'null' ? 'N/A' : item.address}</p>
                        {/* <p style={{ margin: 0 }}>State :  {item.state == 'null' ? 'N/A' : item.state}</p>
                        <p style={{ margin: 0 }}>Zip Code : {item.zipcode == 'null' ? 'N/A' : item.zipcode}</p> */}
                      </div>
                    );
                  })}
                </>
              ) : (
                <>
                  <div>
                    <span>{t("Address")}</span>
                    <p>No Address</p>
                  </div>
                </>
              )}
            </div>
            {role == roles.cleaner && (
              <div className={styles.subContentColRight}>
                <span>{t("Category")}</span>
                <p>{user?.category_name}</p>
              </div>
            )}
          </div>}
          {role == roles.cleaner && (
            <div className={styles.subContentRow}>
              <div className={styles.subContentColLeft}>
                <span>{t("Work Hours")}</span>
                <div>
                  <p>
                    {moment(user?.working_start_time, "HHmmss").format(
                      "hh:mm A"
                    )}{" "}
                    to{" "}
                    {moment(user?.working_end_time, "HHmmss").format("hh:mm A")}
                  </p>
                </div>
              </div>
              <div className={styles.subContentColRight}>
                <span>{t("Break Hours")}</span>
                <p>
                  {moment(user?.break_time_in, "HHmmss").format(
                    "hh:mm A"
                  )}{" "}
                  to{" "}
                  {moment(user?.break_time_out, "HHmmss").format("hh:mm A")}
                </p>
              </div>
            </div>

          )}
          <div className={styles.Buttons}>
            <AntdSubmit
              text={t("Edit Profile")}
              onClick={() => navigate("/editprofile")}
              buttonStyle={{ width: "100%", height: "50px" }}
              className={styles.editBtn}
            />
            <AntdSubmit
              onClick={() => dispatch(AuthMiddleware.DeleteAccount())}
              className={styles.editBtn}
              text={t("Delete Account")}
              buttonStyle={{ width: "100%", height: "50px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Profile;
